import palette from '@/theme/palette.ts';

export const styles = {
  divider: {
    width: '2px',
    height: '30px',
    margin: '0 10px',
    backgroundColor: palette.border.pink,
  },
  listItem: {
    typography: 'subtitle2',
    color: palette.primary.main,
    textTransform: 'uppercase',
    fontWeight: '600',
  },
};
